import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSolarsystem = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 3.02002H11.25V4.52002H12.75V3.02002Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.60387 4.5351L6.54321 5.59576L7.60387 6.65642L8.66453 5.59576L7.60387 4.5351Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.52002 9.25003H5.02002V10.75H6.52002V9.25003Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.98 9.25003H17.48V10.75H18.98V9.25003Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4064 4.54261L15.3457 5.60327L16.4064 6.66393L17.467 5.60327L16.4064 4.54261Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 12H17.12C16.6996 13.0653 15.9588 13.9738 15 14.6V16H13V15.4C12.34 15.5333 11.66 15.5333 11 15.4V16H9V14.6C8.04116 13.9738 7.3004 13.0653 6.88 12H3V22H21V12H19ZM7 20H5V18H7V20ZM7 16H5V14H7V16ZM11 20H9V18H11V20ZM15 20H13V18H15V20ZM19 20H17V18H19V20ZM19 16H17V14H19V16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6C10.9391 6 9.92172 6.42143 9.17157 7.17157C8.42143 7.92172 8 8.93913 8 10C8.00296 10.705 8.19645 11.396 8.56 12C8.91417 12.5969 9.41756 13.0914 10.0207 13.4348C10.6238 13.7782 11.3059 13.9588 12 13.9588C12.6941 13.9588 13.3762 13.7782 13.9793 13.4348C14.5824 13.0914 15.0858 12.5969 15.44 12C15.8036 11.396 15.997 10.705 16 10C16 8.93913 15.5786 7.92172 14.8284 7.17157C14.0783 6.42143 13.0609 6 12 6Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconSolarsystem;
